import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import imagen1 from '../img/get_view1.jpg'; 
import Sidebar from '../componenteExtra/SidebarAdmin';
import {FaClipboardList, FaUser } from 'react-icons/fa';
import Footer from '../componenteExtra/Footer';
import SessionManager from '../componenteExtra/SessionManager';

const MenuAdmin = () => {
    const navigate = useNavigate();
    const [nombre, setNombre] = useState('');
    const [grupo, setGrupo] = useState('');

    useEffect(() => {
        // Obtener el nombre y grupo del localStorage
        const storedNombre = localStorage.getItem('nombre_get');
        const storedGrupo = localStorage.getItem('grupo');
        if (storedNombre) setNombre(storedNombre);
        if (storedGrupo) setGrupo(storedGrupo);
    }, []);

    return (
        <div className="app">
            <SessionManager />
            <div className="main-content">
                <Sidebar />
                <div className="main-panel">
                    <div className="welcome-message">
                        <h2>Bienvenido(a) administrador - {nombre}</h2>
                        <img src={imagen1} alt="Decorative" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <div className="cards-container">
                        <div className="card">
                            <div className="card-header">
                                <FaClipboardList />
                                <h3>Usuarios GET View</h3>
                            </div>
                            <div className="card-subtitle">Acceso Directo</div>
                            <div className="card-content">
                                Este módulo gestiona los usuarios del sistema GET View.
                            </div>
                            <button onClick={() => navigate('/VerUsuarios')}>Ir a ver usuarios GET View</button>
                        </div>
                        <div className="card">
                            <div className="card-header">
                                <FaUser />
                                <h3>Asistentes GET</h3>
                            </div>
                            <div className="card-subtitle">Acceso Directo</div>
                            <div className="card-content">
                                Este módulo gestiona los asistentes GET.
                            </div>
                            <button onClick={() => navigate('/Asistentes')}>Ir a asistentes GET</button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MenuAdmin;
